// Kinds of admin-managed reference data. All of them live in the single `reference_items` table,
// told apart by its `type` column; the value also names the type in /reference/:type URLs.
export const REFERENCE_TYPES = {
  CATEGORY: 'category',
  CORE_VALUE: 'core-value',
  FRAMEWORK: 'framework',
  COUNTRY: 'country',
  DEPARTMENT: 'department',
  TRACK: 'track',
  JOB_GRADE: 'job-grade',
} as const;

export type ReferenceType = (typeof REFERENCE_TYPES)[keyof typeof REFERENCE_TYPES];

export const REFERENCE_TYPE_VALUES = Object.values(REFERENCE_TYPES) as [ReferenceType, ...ReferenceType[]];
